module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_primærlogo_sentrert_logo_pos.89c73951.png";